<template>
  <div :class="['orderBox', order.status === -1 ? 'cancled' : '']">
    <div class="cancleIcon" v-if="order.status === -1">
      <image src="/images/mei/cancled.png" />
    </div>

    <div class="headBar">
      <div class="userInfo">
      
        <div class="nickName">
          {{ order.customer.name }}
        </div>
      </div>

      <div class="orderNo">{{ order.createAt.time3 }}</div>
    </div>
    
    <div class="headBar">
      <div class="orderType">{{ order.orderNo }}</div>
      <div class="orderStatus">
        <text v-if="order.status === 0">待支付</text>
        <text v-if="order.status >= 1">已完成</text>
        <text v-if="order.status === -1">已取消</text>
      </div>
    </div>
    
    <div class="mainContent">
   <div v-for="item in order.productList" :key="item._id" class="productItem">
        <div class="proudctInfo">
          <div class="productTitle">
            
            <div class="title">
              {{ item.name }}
              <text class="cika" v-if="order.type === 2">({{ order.product.name }}x{{ order.cardCount }})</text>
              <text class="shl" v-if="order.type === 1"> x{{ item.shl }}</text>
              <text class="shl" v-if="order.type === 4"> ({{ order.investAmount / 100 }}元)</text>
              <text class="shl" v-if="order.type === 3"> ({{ order.discount / 10 }}折)</text>
            </div>
          </div>
          <div class="productNote">
            <div v-if="item.typeInfo === 'cika'" class="price">次卡抵销</div>
            <div v-else class="price">￥{{ item.realPay / 100 }}</div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="footerBar">
      <div></div>
      <div class="orderStatus">
        实付：￥{{ order.realPay / 100 }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
defineProps({
  order: {
    type: Object,
    required: true
  }
})
</script>

<style scoped>
.orderBox {
  padding: 3vw 4vw;
  width: 100%;
 
 
  box-sizing: border-box;
  background-color: white;
  margin-bottom: 5vw;
  font-size: 0.9rem;
 
}
.userInfo .type{
  margin-left:3vw;
 
   padding: 0 1vw;
}

.headBar,
.footerBar {
 
  display: flex;
  justify-content: space-between;

 
}
.headBar{
margin-bottom: 5px;
}
.footerBar{
  margin-top: 5px;
}

.headBar .userInfo {
}

.headBar .orderStatus {
}

 .cancled{
    color:rgb(139, 139, 139);
  background-color: rgb(250, 250, 250);
 position: relative;
 }
 .cancleIcon{
   position: absolute;
   width:10vw;
   height: 10vw;
   bottom: 8vw;
   right: 30%;
 }
 .cancleIcon image{
   width:100%;
   height: 100%;
 }


.userInfo {
  display: flex;

width:40vw;

}

.userInfo .imageBox {
  padding-top: 0.6vw;
  margin-right: 2vw;
  width:5vw;
  height:5vw;
}

.userInfo .imageBox image {
  width: 5vw;
  height:5vw;
}

.mainContent .productItem .proudctInfo {
  display: flex;
  justify-content: space-between;
  padding:  1vw 0;
}

.mainContent .productItem .proudctInfo .productTitle {
  width:56vw;
  display: flex;
  justify-content: flex-start;
}

.mainContent .productItem .proudctInfo .productTitle .icon{
  width: 6vw;
  padding-top:1vw;
}

.mainContent .productItem .proudctInfo .productNote {
  width: 28vw;
  text-align: right;
 
 

}
</style>